import { createReducer, INITIAL_STATE } from '../../../shared/redux';

export const SIGN_UP_CONFIRMATION_SUBMITTED = '@auth/SIGN_UP_CONFIRMATION_SUBMITTED';
export const SIGN_UP_CONFIRMATION_ACCEPTED = '@auth/SIGN_UP_CONFIRMATION_ACCEPTED';
export const SIGN_UP_CONFIRMATION_REJECTED = '@auth/SIGN_UP_CONFIRMATION_REJECTED';
export const SIGN_UP_CONFIRMATION_RESEND_REQUESTED = '@auth/SIGN_UP_CONFIRMATION_RESEND_REQUESTED';
export const SIGN_UP_CONFIRMATION_RESEND_ACCEPTED = '@auth/SIGN_UP_CONFIRMATION_RESEND_ACCEPTED';
export const SIGN_UP_CONFIRMATION_RESEND_REJECTED = '@auth/SIGN_UP_CONFIRMATION_RESEND_REJECTED';
export const SIGN_UP_CONFIRMATION_INVALID_CODE_EXCEPTION_RAISED = '@auth/SIGN_UP_CONFIRMATION_INVALID_CODE_EXCEPTION_RAISED';
export const SIGN_UP_CONFIRMATION_UNKNOWN_EXCEPTION_RAISED = '@auth/SIGN_UP_CONFIRMATION_UNKNOWN_EXCEPTION_RAISED';

export const getSignUpConfirmationError = state => state.auth.signUpConfirmation.error;
export const isSignUpConfirmationLoading = state => state.auth.signUpConfirmation.loading;
export const isSendingCodeAgain = state => state.auth.signUpConfirmation.isSendingCodeAgain;

export const submitSignUpConfirmation = ({ username, code }) => ({
    type: SIGN_UP_CONFIRMATION_SUBMITTED,
    payload: { username, code },
});

export const resendSignUpConfirmation = ({ username }) => ({
    type: SIGN_UP_CONFIRMATION_RESEND_REQUESTED,
    payload: { username },
});

export const acceptResendSignUpConfirmation = () => ({
    type: SIGN_UP_CONFIRMATION_RESEND_ACCEPTED,
    payload: {},
});

export const rejectResendSignUpConfirmation = ({ error }) => ({
    type: SIGN_UP_CONFIRMATION_RESEND_REJECTED,
    payload: { error },
});

export const acceptSignUpConfirmation = ({ user }) => ({
    type: SIGN_UP_CONFIRMATION_ACCEPTED,
    payload: { user },
});

export const rejectSignUpConfirmation = ({ error }) => ({
    type: SIGN_UP_CONFIRMATION_REJECTED,
    payload: { error },
});

export const raiseSignUpConfirmationInvalidCodeException = ({ message }) => ({
    type: SIGN_UP_CONFIRMATION_INVALID_CODE_EXCEPTION_RAISED,
    payload: { message },
});

export const raiseSignUpConfirmationUnknownException = ({ message }) => ({
    type: SIGN_UP_CONFIRMATION_UNKNOWN_EXCEPTION_RAISED,
    payload: { message },
});

const updateError = (state = {}, action) => ({
    ...state,
    error: action.payload.message,
    loading: false,
});

export const signUpConfirmationReducer = createReducer({
    [INITIAL_STATE]: {
        error: null,
        loading: false,
        isSendingCodeAgain: false,
    },
    [SIGN_UP_CONFIRMATION_INVALID_CODE_EXCEPTION_RAISED]: updateError,
    [SIGN_UP_CONFIRMATION_UNKNOWN_EXCEPTION_RAISED]: updateError,
    [SIGN_UP_CONFIRMATION_RESEND_REQUESTED]: state => ({
        ...state,
        error: null,
        loading: true,
        isSendingCodeAgain: false,
    }),
    [SIGN_UP_CONFIRMATION_RESEND_ACCEPTED]: state => ({
        ...state,
        loading: false,
        isSendingCodeAgain: true,
    }),
});
